import styled from 'styled-components';
import {
  Switch,
} from 'antd';
import {
  COLOR_CV_5,
} from 'constants/colors';

export const StyledAntdSwitch = styled(Switch)`
  &.ant-switch-checked {
    background-color: ${COLOR_CV_5};
    --antd-wave-shadow-color: ${COLOR_CV_5};

    &:focus {
      box-shadow: 0 0 0 2px ${COLOR_CV_5}20;
    }
  }
`;
